import { Pipe, PipeTransform } from '@angular/core';
import { Option } from '@dch/products-business-logic';

@Pipe({
  name: 'filterByOptionCategory',
})
export class FilterByOptionCategoryPipe implements PipeTransform {
  transform(values: Option[], selectedCategory: string): any {
    if (selectedCategory === undefined) {
      return values;
    } else {
      return (values || []).filter(
        (v) => v.categories && v.categories.indexOf(selectedCategory) > -1,
      );
    }
  }
}
